window.globalImages = {};
window.offsetTime = undefined;
var global = global || window;

(function () {
    var cookies = document.cookie.split("; ");
    for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split(".");
        while (d.length > 0) {
            var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            var p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            };
            d.shift();
        }
    }
})();

navigator &&
    navigator.serviceWorker &&
    navigator.serviceWorker.getRegistrations &&
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        if (!registrations.length) {
            return;
        }
        registrations.forEach((registration) => {
            registration.unregister().then(function (boolean) {
                console.log(
                    boolean ? 'Successfully unregistered' : 'Failed to unregister',
                    'ServiceWorkerRegistration\n' +
                        (registration.installing ? '  .installing.scriptURL = ' + registration.installing.scriptURL + '\n' : '') +
                        (registration.waiting ? '  .waiting.scriptURL = ' + registration.waiting.scriptURL + '\n' : '') +
                        (registration.active ? '  .active.scriptURL = ' + registration.active.scriptURL + '\n' : '') +
                        '  .scope: ' +
                        registration.scope +
                        '\n'
                );
            });
        });
    });
